var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwipeLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.294 18.8041C16.2837 18.532 16.9713 17.6116 16.9695 16.5607L16.9594 12.3253C16.9566 11.1328 16.0704 10.1373 14.9113 10.0256L12.0841 9.75168C11.5201 9.69726 11.0486 9.28911 10.9012 8.72803L10.1742 5.948C9.93614 5.03506 9.02055 4.49368 8.12969 4.73856C7.23884 4.9825 6.71055 5.92078 6.94951 6.83372L8.8063 13.9363C8.8356 14.048 8.70467 14.1296 8.62135 14.0527L7.98778 13.4681C6.99438 12.5515 5.44515 12.7147 4.6541 13.819L4.58451 13.9157C4.48838 14.0499 4.49845 14.2337 4.6074 14.3557L8.97661 19.2468C9.54518 19.8839 10.4141 20.1438 11.228 19.9205L15.294 18.8041Z",
    fill: "#FF7681"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4883 5.6414C13.1914 0.174051 5.45568 0.109438 2.07161 5.51943C1.8537 5.86846 1.40049 5.9698 1.0599 5.74649C0.719311 5.52225 0.620423 5.05874 0.83833 4.70971C4.80462 -1.631 13.8707 -1.5551 17.7343 4.85138L17.8909 5.11128C18.1033 5.46408 17.9971 5.92662 17.6529 6.14431C17.3086 6.36293 16.8572 6.25315 16.6448 5.90037L16.4883 5.6414Z",
    fill: "#FF7681"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25333 5.11413C5.30003 5.52601 5.01255 5.89851 4.6106 5.94732L1.79257 6.28415C0.974954 6.38173 0.24341 5.75778 0.189407 4.91616L0.00171474 2.01506C-0.0257531 1.60128 0.280049 1.24382 0.683827 1.2166C1.08761 1.18845 1.43642 1.50183 1.46298 1.91562L1.64884 4.78957L4.44132 4.45555C4.84233 4.4077 5.20664 4.70221 5.25333 5.11413Z",
    fill: "#FF7681"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeLeft);
export default __webpack_public_path__ + "static/media/swipe-left.4c09cb470c5651bd1160244b02fc972a.svg";
export { ForwardRef as ReactComponent };